var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturninline = function SvgReturninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212120",
    clipPath: "url(#return_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.498 19.258a8.08 8.08 0 0 1-8.07-8.07h.855a7.214 7.214 0 1 0 7.621-7.205l.051-.856a8.07 8.07 0 0 1-.457 16.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 6.662 6.183 3.547 9.3.427l.603.604-2.511 2.516 2.511 2.512z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "return_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.428.428h16.14v18.83H.428z"
  })))));
};
export default SvgReturninline;